<template>
  <section id="advantages" class="advantages">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">核心优势</h2>
        <p class="section-subtitle">我们以专业、创新、可靠的服务赢得客户信赖</p>
      </div>
      <div class="advantages-grid">
        <div class="advantage-card">
          <div class="advantage-icon">🏆</div>
          <h3 class="advantage-title">资质齐全</h3>
          <p class="advantage-description">
            拥有城市生活垃圾经营性服务等多项专业资质，合法合规经营，让客户合作更放心。
          </p>
        </div>
        <div class="advantage-card">
          <div class="advantage-icon">👨‍💻</div>
          <h3 class="advantage-title">技术专业</h3>
          <p class="advantage-description">
            团队由资深技术专家组成，具备丰富的行业经验和深厚的技术功底，确保项目高质量交付。
          </p>
        </div>
        <div class="advantage-card">
          <div class="advantage-icon">🔄</div>
          <h3 class="advantage-title">服务全面</h3>
          <p class="advantage-description">
            从技术开发到环保设备销售，提供一站式综合服务，满足企业多元化的数字化与环保需求。
          </p>
        </div>
        <div class="advantage-card">
          <div class="advantage-icon">🤝</div>
          <h3 class="advantage-title">客户导向</h3>
          <p class="advantage-description">
            始终以客户需求为中心，提供个性化定制方案，建立长期稳定的合作伙伴关系。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppAdvantages'
};
</script>

<style scoped>
.advantages {
  padding: 5rem 2rem;
  background: linear-gradient(135deg, #0A2647 0%, #1E5AA8 100%);
  color: white;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: white;
}

.section-subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2.5rem;
}

.advantage-card {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 2.5rem 2rem;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.advantage-card:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-5px);
  border-color: rgba(255, 255, 255, 0.3);
}

.advantage-icon {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
}

.advantage-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.advantage-description {
  font-size: 1rem;
  line-height: 1.7;
  opacity: 0.9;
}

@media (max-width: 768px) {
  .advantages {
    padding: 3rem 1.5rem;
  }
  .advantages-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}
</style>